<template>
  <button
    class="base-button"
    :class="[
      `-variant-${variant}`,
      `-size-${size}`,
      `-left-align-${leftAligned}`,
    ]"
    :type="type"
    :disabled="disabled"
  >
    <BaseIcon
      v-if="icon"
      :icon="icon"
      :size="16"
    />
    <slot />
  </button>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  variant: {
    type: String,
    default: 'primary',
  },
  size: {
    type: String,
    default: 'regular',
  },
  type: {
    type: String,
    default: 'button',
  },
  leftAligned: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: null,
  },
});
</script>

<style scoped>
.base-button {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: var(--blue);
  border: 2px solid transparent;
  width: 100%;
  font-weight: 700;
  cursor: pointer;
  border-radius: var(--border-radius);
  line-height: 1;

  &.-variant-primary {
    background-color: var(--blue);
    color: var(--white);
    &:hover {
      background-color: var(--blue-dark);
    }
  }
  &.-variant-secondary {
    background-color: var(--yellow);
    &:hover {
      background-color: var(--yellow-dark);
    }
  }
  &.-variant-tertiary {
    background-color: var(--gray-200);
    &:hover {
      background-color: var(--gray-300);
    }
  }
  &.-variant-ghost {
    border-color: var(--blue);
    color: var(--blue);
    &:hover {
      background-color: var(--elevated);
    }
  }
  &.-variant-link {
    text-decoration: underline;
  }
  &.-variant-link-danger {
    text-decoration: underline;
    color: var(--red);
  }

  &.-size-regular {
    padding: 17px 16px;
    font-size: var(--font-size-300);
  }
  &.-size-small {
    padding: 13px 16px;
    font-size: var(--font-size-100);
    width: fit-content;
  }

  &.-left-align-true {
    padding-left: 0;
    padding-right: 0;
    width: fit-content;
  }

  &[disabled] {
    background-color: var(--disabled-background) !important;
    color: var(--disabled-text) !important;;
    cursor: not-allowed;
  }
}
</style>
